import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById } from '@/redux/reducers/consultation.reducer'
import { selectRoomByConsultationId } from '@/redux/reducers/room.reducer'

export function useConsultationState(consultationId?: string) {
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))
  const room = useAppSelector((state) => (consultationId ? selectRoomByConsultationId(state, consultationId) : undefined))

  return { consultation, room }
}
